<template>
  <div class="bg">
    <div class="container">
      <div class="apply-title">
        <span class="apply-title-h"
          >您正在报名参加{{ classInfo.className }}</span
        >
      </div>
      <div class="card conttop">
        <div class="hint-mobile">
          <span>
            手机号为登录平台、参加培训的唯一凭证，请勿重复填写手机号。
          </span>
        </div>
        <div class="apply-table">
          <el-table :data="tableData" border>
            <el-table-column align="center" label="姓名">
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入内容"
                  v-show="scope.row.show"
                  v-model="scope.row.userName"
                ></el-input>
                <span v-show="!scope.row.show">{{ scope.row.userName }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="性别">
              <template slot-scope="scope">
                <!-- <el-input placeholder="请输入内容" v-show="scope.row.show" v-model="scope.row.userGender"></el-input> -->
                <el-select
                  v-model="scope.row.userGender"
                  v-show="scope.row.show"
                  placeholder="请选择性别"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <span v-show="!scope.row.show">{{ scope.row.userGender }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="手机号">
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入内容"
                  v-show="scope.row.show"
                  v-model="scope.row.userMobile"
                ></el-input>
                <span v-show="!scope.row.show">{{ scope.row.userMobile }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="电子邮箱">
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入内容"
                  v-show="scope.row.show"
                  v-model="scope.row.userEmail"
                ></el-input>
                <span v-show="!scope.row.show">{{ scope.row.userEmail }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="工作单位">
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入内容"
                  v-show="scope.row.show"
                  v-model="scope.row.userCompany"
                ></el-input>
                <span v-show="!scope.row.show">{{
                  scope.row.userCompany
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="250px" label="操作">
              <template slot-scope="scope">
                <!-- <el-button
                v-if="scope.row.show"
                style="background: #dc2325; color: #ffffff"
                size="mini"
                @click="save(scope.row)"
                >保存
              </el-button> -->

                <div class="rotbosCon">
                  <div
                    v-if="scope.row.show"
                    class="rowbutns bao"
                    @click="save(scope.row)"
                  >
                    <img src="@/assets/image/保存.png" alt="" />
                    保存
                  </div>
                  <div v-if="scope.row.show" class="shu"></div>
                  <div
                    class="rowbutns dele"
                    v-if="scope.row.show"
                    @click="del(scope.$index)"
                  >
                    <img src="@/assets/image/删除.png" alt="" />
                    删除
                  </div>
                  <span
                    v-else
                    style="color: #42cd73; font-size: 14px; font-weight: 400"
                    >通过</span
                  >
                </div>

                <!-- <el-button
                v-if="scope.row.show"
                style="background: #dc2325; color: #ffffff"
                size="mini"
                @click="del(scope.$index)"
                >删除
              </el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="apply-footer">
          <el-button class="btns" @click="addRow">添加学员 </el-button>
          <el-button class="btns btnsce" @click="createOrder"
            >添加完成
          </el-button>
        </div>
      </div>

      <div class="content3 card">
        <div class="car-title">
          <span>付款方式</span>
        </div>
        <div class="pt">
          <div class="finso">
            <el-radio v-model="radio2" label="0" border size="medium">
              <div class="fanslist">
                <img src="@/assets/image/支付宝支付.png" />
                支付宝支付
              </div>
            </el-radio>
            <el-radio v-model="radio2" label="1" border size="medium">
              <div class="fanslist">
                <img src="@/assets/image/微信.png" alt="" />
                微信支付
              </div>
            </el-radio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import cookie from "@/api/cookie";

export default {
  name: "index",
  data() {
    return {
      tableData: [
        {
          userName: "",
          userGender: "",
          userMobile: "",
          userEmail: "",
          userCompany: "",
          show: true,
        },
      ],
      radio2: "", //支付方式 0支付宝 1微信
      options: [
        {
          value: "男",
          label: "男",
        },
        {
          value: "女",
          label: "女",
        },
      ],
      classInfo: {},
      orderNo: "",
      res: 0,
    };
  },
  mounted() {
    this.getOrderNo();
  },
  methods: {
    del(index) {
      this.tableData.splice(index, 1);
    },
    getOrderNo() {
      api.createOrderNo().then((res) => {
        this.orderNo = res.data;
      });
    },
    addRow() {
      this.tableData.push({
        userName: "",
        userGender: "",
        userMobile: "",
        userEmail: "",
        userCompany: "",
        show: true,
      });
    },
    detection_mobile(mobile) {
      this.tableData.map((itm) => {
        if (itm.userMobile === mobile) {
          this.res++;
        }
      });
    },
    open() {
      this.$confirm("该手机号重复，请重新填写?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: false,
        type: "warning",
      }).then(() => {
        // data.show = false;
        this.$message({
          type: "info",
          message: "请修改信息",
        });
      });
      // .catch(() => {
      //   this.$message({
      //     type: "info",
      //     message: "请修改信息",
      //   });
      // });
    },
    async save(data) {
      this.res = 0;
      this.detection_mobile(data.userMobile);

      let reg = /^1[23456789]\d{9}$/;
      if (
        data.userName === "" ||
        data.userGender === "" ||
        data.userMobile === "" ||
        data.userEmail === "" ||
        data.userCompany === ""
      ) {
        this.$message.error("请完善学员信息");
      } else if (this.res === 2) {
        this.open(data);
      } else if (reg.test(data.userMobile) === false) {
        this.$message.error("请输入正确的手机号");
      } else {
        const pars = {
          phone:data.userMobile,
          classId:this.$route.query.id
        }
        const rest = await api.getCourseCount(pars)
        if(rest.data>0){
          return this.$message.error(data.userName+"已报名此培训，请核实！");
        }
        data.show = false;
      }
    },
    createOrder() {
      console.log(this.radio2);
      if (!cookie.getCookie("userId")) {
        this.$message.error("请重新登录");
      }
      if (this.tableData[this.tableData.length - 1].show === true) {
        this.$message.error("请保存全部信息");
      } else if (this.radio2 === "") {
        this.$message.error("请选择支付方式");
      } else {
        let data = {
          orderNo: this.orderNo,
          createTime: new Date().getTime(),
          body: this.classInfo.className,
          classId: this.$route.query.id,
          subject: this.classInfo.className,
          totalAmount: this.tableData.length * this.classInfo.price,
          userId: cookie.getCookie("userId"),
          type: this.radio2, //支付方式 0支付宝1微信 2微信移动端 3对公付款
          price: this.classInfo.price, //单价
        };
        const loading = this.$loading({
          lock: true,
          text: "正在报名,请稍等",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        api
          .creatOrder(data)
          .then((res) => {
            const orderId = res.data.ordersId;
            const promises = this.tableData.map((item) => {
              return api.apply(item).then((res) => {
                const data = {
                  createTime: res.data.createTime,
                  orderId,
                  reUserId: res.data.userId,
                };
                return api.userOrderLog(data);
              });
            });
            Promise.all(promises)
              .then(() => {
                loading.close();
                this.$router.push({ path: "/order", query: res.data });
              })
              .catch(() => {
                loading.close();
              });
          })
          .catch(() => {
            loading.close();
          });
      }
    },
    getClassForId(id) {
      api.classForId(id).then((res) => {
        this.classInfo = res.data;
      });
    },
  },
  created() {
    this.getClassForId(this.$route.query.id);
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 1200px;
  min-height: 500px;
  margin: 10px auto;
  padding: 10px;

  .apply-title {
    margin-bottom: 20px;
    .apply-title-h {
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 14px;
      color: #888888;
      line-height: 20px;
      text-align: center;
    }
  }

  .apply-table {
    margin: 20px 0;
  }

  .apply-footer {
    .btns {
      width: 140px;
      height: 38px;
      background: #264f99;
      border-radius: 4px;
      padding: 0px;
      color: #ffffff;
      font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
    .btnsce {
      border: 1px solid #666666;
      background: none;
      color: #333333;
    }
  }
}

.conttop {
  min-height: 360px;
  .hint-mobile {
    margin-top: 10px;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 25px;
  }
}

.content3 {
  margin-top: 20px;
  padding: 10px;

  .first {
    width: 75px;
  }

  .pt {
    margin-top: 13px;
    margin-bottom: 9px;
    .finso {
      ::v-deep .el-radio {
        display: inline-flex;
        width: 262px;
        height: 92px;
        align-items: center;
        padding: 0px;
        justify-content: center;
        .el-radio__label {
          color: #333333;
          font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          line-height: 25px;
        }
        .el-radio__input.is-checked .el-radio__inner {
          background: #264f99;
        }
      }
      ::v-deep .is-checked {
        background: #eef1f6;
      }
      .fanslist {
        img {
          width: 36px;
          height: 36px;
          margin-right: 10px;
        }
        display: flex;
        align-items: center;
      }
    }
  }
}

.card {
  width: 1200px;
  background: #ffffff;
  padding: 24px 20px;
  box-sizing: border-box;
  .car-title {
    position: relative;
    text-align: left;
    padding-left: 8px;
    height: 22px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 16px;
    color: #264f99;
    line-height: 22px;
    text-align: justify;
    font-style: normal;
  }
  .car-title::before {
    content: "";
    width: 4px;
    height: 12px;
    background: #264f99;
    display: block;
    position: absolute;
    top: 6px;
    left: 0px;
  }
}

.rotbosCon {
  display: flex;
  align-items: center;
  justify-content: center;
  .rowbutns {
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .bao {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #264f99;
    line-height: 20px;
  }
  .dele {
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 400;
    font-size: 14px;
    color: #dc2326;
    line-height: 20px;
  }
  .shu {
    width: 1px;
    height: 16px;
    border: 1px solid #000000;
    opacity: 0.2;
    margin: 0px 16px;
  }
}

::v-deep .has-gutter {
  .el-table__cell {
    background: #f6f7fb;
  }
}

::v-deep .el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border: none;
}
</style>
